const REQUIRED = ['./index.html', './assets/app.js', './assets/app.css', './manifest.webmanifest'];

// Registration alone is not proof: installation must have cached this build.
export async function checkOfflineReady({ cacheStorage, buildId } = {}) {
  if (!cacheStorage || !/^[0-9a-f]{16}$/.test(buildId || '')) return { ready: false };
  try {
    const name = `lumichat-${buildId}`;
    if (!(await cacheStorage.keys()).includes(name)) return { ready: false };
    const cache = await cacheStorage.open(name);
    for (const asset of REQUIRED) {
      if (!(await cache.match(asset))?.ok) return { ready: false };
    }
    return { ready: true };
  } catch { return { ready: false }; }
}
